<div>
    <div class="advertisement-inner mt-2">
        <img [src]="imageUrl" alt="Advertisement" loading="lazy">
    </div>
</div>
